<template>
  <a href="tel:18556974232" class="tw-group tw-bg-red-500 tw-flex tw-items-center tw-mb-8 tw-rounded-2xl tw-py-4 tw-px-4 tw-text-white hover:tw-text-red-100 hover:tw-bg-red-700">
    <div class="tw-text-2xl sm:tw-text-md lg:tw-text-lg xl:tw-text-xl 2xl:tw-text-2xl tw-italic">
      Need help<br/>with catering?
    </div>
  <div class="tw-border-l tw-border-white group-hover:tw-border-red-100 tw-ml-8 tw-pl-8 tw-text-xl sm:tw-text-xl lg:tw-text-xl xl:tw-text-xl 2xl:tw-text-4xl tw-font-bold tw-py-4">
   <span class="fa fa-phone tw-rotate-115 tw-inline-block tw-mr-2"></span> 855.MYPIADA
    </div>
  </a>
  <p><i>Questions? Check out our <a href="/faq-catering" class="tw-text-orange-medium">FAQs</a>.</i></p>
</template>